const regions = [
  {
    name: "North America"
  },
  {
    name: "Central/South America"
  },
  {
    name: "Asia/Pacific"
  },
  {
    name: "Europe"
  },
  {
    name: "Eastern Europe"
  },
  {
    name: "Middle East"
  },
  {
    name: "Africa"
  },
  {
    name: "Antartica"
  }
].sort((a, b) => a.name.localeCompare(b.name));

export default regions;



// WEBPACK FOOTER //
// ./app/lib/regions.js